import { Link } from 'react-router-dom';
import { PlusCircle } from 'lucide-react';

import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from '@/components/ui/card';
import LoadingPage from '@/components/common/LoadingPage';
import Error from '@/components/common/Error';
import { Button } from '@/components/ui/button';

import ActivityList from './components/list/ActivityList';

import { useActivitiesV2 } from '@/data/activity';

const ListActivitiesPage = () => {
  const activities = useActivitiesV2();

  if (activities.isLoading && !activities.data) {
    return <LoadingPage />;
  }

  if (activities.error) {
    return <Error error="There was an error loading activities" />;
  }

  return (
    <Card className="max-w-6xl mx-auto">
      <CardHeader>
        <div className="flex justify-between">
          <div className="space-y-1">
            <CardTitle>Activities</CardTitle>
            <CardDescription>
              Manage the Activities that ProFound supports.
            </CardDescription>
          </div>
          <Button variant="default" asChild>
            <Link to="/activity/add">
              <PlusCircle />
              Add Activity
            </Link>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <ActivityList />
      </CardContent>
    </Card>
  );
};

export default ListActivitiesPage;
